import Schedule          from './Schedule.jsx';
import Wrapper           from '../../assets/wrappers/JobsContainer';
import SchedulePaginationContainer from './SchedulePaginationContainer.jsx';
import { useAllSchedulesContext }  from '../../pages/AllCampaignSchedules.jsx';

const SchedulesContainer = () => {
  const { data } = useAllSchedulesContext();
  const { schedules, totalSchedules, numOfPages } = data;

  if (schedules.length === 0) {
    return (
      <Wrapper>
        <h5>לא נמצאו תזמונים להצגה…</h5>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>נמצאו {totalSchedules} תזמונים</h5>

      <div className='jobs'>
        {schedules.map((sch) => (
          <Schedule key={sch._id} {...sch} />
        ))}
      </div>

      {numOfPages > 1 && <SchedulePaginationContainer />}
    </Wrapper>
  );
};

export default SchedulesContainer;
